import React from 'react';
import { Table, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

/** A column title with an (i) tooltip. */
export const titleWithInfo = (title: string, info: string): React.ReactNode => (
  <Tooltip title={info}>
    <span>
      {title} <InfoCircleOutlined aria-label={info} />
    </span>
  </Tooltip>
);

/**
 * The footer row of a table: "Total" and the sums. Cells are given in column order; a column that
 * must not be summed (users, rates, days) gets null and shows nothing.
 */
export function totalRow(cells: Array<React.ReactNode | null>): React.ReactNode {
  return (
    <Table.Summary fixed>
      <Table.Summary.Row data-total="1">
        {cells.map((cell, i) => (
          <Table.Summary.Cell key={i} index={i} align={i === 0 ? 'left' : 'right'}>
            {i === 0 ? <b>Total</b> : cell}
          </Table.Summary.Cell>
        ))}
      </Table.Summary.Row>
    </Table.Summary>
  );
}
